import { render, staticRenderFns } from "./EditOrdo.vue?vue&type=template&id=6c3fd178&"
import script from "./EditOrdo.vue?vue&type=script&lang=js&"
export * from "./EditOrdo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports